import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { InformacionGeneralTabProps } from "../MantenimientosDetail.type"

const emptyValue = "-"

const formatValue = (value?: string | null) =>
    value && value !== emptyValue ? formatTextWithCapitalize(value) : emptyValue

const InformacionGeneralTab = ({ data }: InformacionGeneralTabProps): JSX.Element => {
    // las fechas del reporte ya llegan formateadas desde el endpoint, se muestran igual que en la tabla
    return (
        <div className="mantto-detail__description">
            <DescriptionDetail
                icon={"tools"}
                label={"Tipo de mantenimiento"}
                value={formatValue(data?.tipo_mantto)}
            />
            <DescriptionDetail
                className={"mantto-detail__value--full"}
                icon={"draft"}
                label={"Motivo de mantenimiento"}
                value={data?.motivo_mantto || emptyValue}
            />
            <DescriptionDetail
                icon={"calendarFill"}
                label={"Fecha de inicio"}
                value={data?.fecha_inicio || emptyValue}
            />
            <DescriptionDetail
                icon={"calendarChecked"}
                label={"Fecha de cierre"}
                value={data?.fecha_termino || emptyValue}
            />
            <DescriptionDetail
                className={"mantto-detail__value--full"}
                icon={"userFilled"}
                label={"Responsable"}
                value={data?.responsable || emptyValue}
            />
            <DescriptionDetail icon={"FileListFill"} label={"Turno"} value={data?.turno || emptyValue} />
        </div>
    )
}

export default InformacionGeneralTab
